import styled, { css } from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';
import { AiOutlineFileText } from 'react-icons/ai';
import { BiTask } from 'react-icons/bi';
import { BsChevronDown } from 'react-icons/bs';

export const Wrapper = styled.main`
  padding-top: 10px;
  padding-left: 7px;
  svg {
    width: 16px !important;
    height: 15px !important;
  }
`;

const S = {} as any;

export const Trigger = styled.div`
  position: relative;
`;

export const Dropdown = styled.div<any>`
  position: absolute;
  z-index: 9;
  display: ${ifProp('isOpen', 'block', 'none')};
  top: 100%;
  left: 0;
  background-color: ${palette('bgInput')};
  box-shadow: ${theme('shadow.sm')};
  border-radius: ${theme('borderRadius.sm')};
  padding: 4px 0;

  ${theme('components.Dropdown.container')}
`;

export const DropdownItem = styled.div<any>`
  display: flex;
  align-items: center;
  padding: ${theme('spacing.xs')} ${theme('spacing.sm')};
  color: ${palette('colorDropdownItem')};
  font-size: ${theme('fontSize.xs')};
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background-color: ${palette('bgDropdownItemHover')};
    color: ${palette('colorDropdownItemHover')};
  }
  ${theme('components.Dropdown.item')}
`;

export const DropdownItemIcon = styled.img`
  width: 14px;
  height: auto;
  margin-right: 10px;
`;

export const DropdownItemLabel = styled.span``;

const iconStyle = css`
  margin-right: 7px;
  color: ${palette('colorBody')};
  transition: ${theme('transition')};
`;

export const TextNoteIcon = styled(AiOutlineFileText)`
  ${iconStyle}
`;
export const MondayIcon = styled(BiTask)`
  ${iconStyle}
`;
export const TriggerDropdownCaret = styled(BsChevronDown)`
  width: 8px;
  color: ${palette('colorDropdownItem')};
`;

export default S;
